import { render } from "./ProducerTable.vue?vue&type=template&id=bbd9dbee&scoped=true"
import script from "./ProducerTable.vue?vue&type=script&lang=js"
export * from "./ProducerTable.vue?vue&type=script&lang=js"

import "./ProducerTable.vue?vue&type=style&index=0&id=bbd9dbee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbd9dbee"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTd});
